<template>
  <div class="preview-square-container p-8">
    <!-- Title controlled by Tenant Regions Wrapper (App.vue) -->

    <!-- Double Dashed Container -->
    <!-- Outer Border -->
    <div class="outer-border border-2 border-dashed border-gray-200 rounded-3xl p-6 bg-white shadow-sm max-w-md mx-auto flex flex-col items-center justify-center relative overlow-hidden" :class="{'aspect-square': !wizardStore.previewImage}">
        
        <!-- Error Banner (replaces alert()) -->
        <div v-if="wizardStore.previewError" class="absolute top-4 left-4 right-4 z-20 flex items-center gap-3 bg-red-50 border border-red-200 text-red-700 rounded-2xl px-5 py-3 shadow-sm">
            <span class="text-lg shrink-0">⚠️</span>
            <span class="font-lds-body text-xs font-semibold flex-1">{{ wizardStore.previewError }}</span>
            <button @click="wizardStore.previewError = null" class="text-red-400 hover:text-red-600 font-bold shrink-0">✕</button>
        </div>

        <!-- Loading State -->
        <div v-if="wizardStore.isGenerating" class="absolute inset-0 z-10 bg-white/90 flex flex-col items-center justify-center">
            <div class="animate-pulse text-6xl mb-4">✨</div>
            <p class="font-lds-heading text-lds-primary font-bold animate-pulse">Dreaming up your match...</p>
        </div>

        <!-- Empty State -->
        <div v-if="!wizardStore.previewImage" class="inner-border w-full h-full border-2 border-dashed border-lds-primary/30 rounded-2xl flex items-center justify-center bg-gray-50/50 p-8 text-center">
            <p class="font-lds-body text-lg text-gray-500 font-medium leading-relaxed">
                Wait until you choose {{ contextType === 'animal' ? 'an' : 'the' }} 
                <span class="text-lds-primary font-bold">{{ contextType }}</span> 
                above!
            </p>
        </div>

        <!-- Preview Content -->
        <div v-else class="w-full flex flex-col items-center gap-6">
            <div class="w-full aspect-square relative rounded-2xl shadow-sm overflow-hidden">
                <img :src="wizardStore.previewImage" class="w-full h-full absolute inset-0 object-cover" />
            </div>
            
            <!-- Always Visible Buttons (below image) -->
            <div class="flex flex-col items-center gap-3 w-full">
                <button 
                    @click="revealMatch"
                    class="bg-lds-primary text-white font-bold py-3 px-8 rounded-full shadow-lg hover:scale-105 transition-transform flex items-center gap-2 w-full max-w-xs justify-center"
                >
                    <span>Reveal Full Match</span>
                    <span>✨</span>
                </button>
                <button 
                    @click="tryAnother"
                    class="bg-gray-100 text-gray-700 border border-gray-200 font-bold py-2 px-8 rounded-full hover:bg-gray-200 hover:scale-105 transition-all w-full max-w-xs flex items-center justify-center gap-2"
                >
                    <span>Keep & Try Another ({{ wizardStore.collectedCount + 1 }}/4)</span>
                    <span>🔄</span>
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useWizardStore } from '@emoji-photo/wizard-island'; 

export default {
  name: 'PreviewSquare',
  props: {
      tenantConfig: { type: Object, default: () => ({}) }
  },
  setup(props) {
    const wizardStore = useWizardStore();

    // Logic to determine context: 'animal' or 'emotion'
    const contextType = computed(() => {
        const features = props.tenantConfig?.features || {};
        if (features.animalsLibraryId || (features.animals && features.animals.length > 0)) {
            return 'animal';
        }
        return 'emotion';
    });

    const revealMatch = () => {
        wizardStore.confirmPreview();
        setTimeout(() => {
             const collageSection = document.querySelector('[data-island-id="CollageIsland"]');
             if (collageSection) collageSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    };

    const tryAnother = () => {
        wizardStore.saveAndTryAnother();
        
        if (wizardStore.collectedCount < 4) {
            setTimeout(() => {
                const emojiSection = document.querySelector('[data-island-id="EmojiIsland"]');
                if (emojiSection) {
                    emojiSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 50);
        }
    };

    return { wizardStore, contextType, revealMatch, tryAnother };
  }
}
</script>

<style scoped>
/* 
  The double border effect is achieved via nesting.
  Outer: border-gray-200
  Inner: border-lds-primary (lighter opacity)
*/
</style>
